import { HttpBackend } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';

@Component({
  selector: 'app-landing-page-video',
  templateUrl: './landing-page-video.component.html',
  styleUrls: ['./landing-page-video.component.scss'],
})
export class LandingPageVideoComponent  implements OnInit {

 videoForm!: FormGroup;
buttonColorName:any;
getPatchData:any;
loggedInUserCompanyID:any
  constructor(private fb: FormBuilder, private dialogRef: MatDialogRef<LandingPageVideoComponent>,
     private encryptionService: EncryptionService,
     @Inject(MAT_DIALOG_DATA) public getData: any,
   private httpService: HttpService, private config: Config,public dialog: MatDialog,) {
    console.log(getData);
    this.getPatchData=getData?.patchData;
    
  }

  ngOnInit(): void {
    this.buttonColorName=sessionStorage.getItem('buttonColorName');
     this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.videoForm = this.fb.group({
      title: ['', Validators.required],
      description: [''],
     
      url: ['',Validators.required]
    });
    if(this.getPatchData){
      this.patchFormData(this.getPatchData)
    }
  }

  patchFormData(data: any) {
  if (data) {
    this.videoForm.patchValue({
      title: data.title || '',
      description: data.description || '',
    
      url: data.url || ''
    });
  }
}
submitted = false;

  onSubmit() {
  this.submitted = true;
  if (this.videoForm.invalid) return;

  let payload={
    "id":this.getPatchData?this.getPatchData?.id:null,
  // "companyId":this.loggedInUserCompanyID ,
  "title": this.videoForm.value.title,
  "description": this.videoForm.value.description,
  "url": this.videoForm.value.url,
  }
    if (this.videoForm.valid) {
    this.httpService.callPostService(this.config.addOrUpdateVideos,payload).subscribe((response:any)=>{
 
        this.showPopup(response.message, 'success', true);
        this.submitted = false; // Reset flag

      },
      (error: any) => {
        this.showPopup(error.error.error || 'An error occurred.', 'danger', false);
        this.submitted = false; // Reset flag
      }
    )
    }
  }
  showPopup(message: string, color: string, isSuccess: boolean) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: message,
        btn2: 'OK',
        btn2BgColor: color,
        showSuccessIcon: isSuccess,
        showSuccessMessage: false,
        showCloseIcon: !isSuccess
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      if (isSuccess) this.dialogRef.close(); // Close only on success
    });
  }
  onCancel() {
  this.dialogRef.close();
  }
}
